import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { FreeCapacityCockpitPageInitialData } from "./freeCapacityCockpitPageTypes";

export const freeCapacityCockpitPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.freeCapacityCockpit(),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<FreeCapacityCockpitPageInitialData>>("/page-data/freecapacitycockpit"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
